export default __webpack_public_path__ + "overview-960-1cbc4aa3bbbcfa75617e29608e0ced1f.png";